import {Component} from '@angular/core';

@Component({
    selector: 'qa-signup-complete',
    templateUrl: './signup-complete.component.html',
    styleUrls: ['./signup-complete.component.scss'],
    standalone: false
})
export class SignupCompleteComponent {

  constructor() { }

}
